import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBtReferralAction } from "../../../redux/actions/referrals";
import useCommonParams from "../../../hooks/useCommonParams";

export default function useGetBtReferallsQuery(enabled = true) {
  const dispatch = useDispatch();

  const { BtReferrals, isBtLoading, totalBtRecords } = useSelector(
    (state) => state.referrals
  );

  const { queryParams } = useCommonParams();

  useEffect(() => {
    if (enabled) {
      dispatch(getBtReferralAction(queryParams));
    }
  }, [queryParams, enabled]);

  return {
    BtReferrals,
    totalBtRecords,
    isBtLoading,
  };
}
